import { AxiosInstance } from 'axios';
import { AppStore } from 'app.store';
import { CEFAuthenticateDomains } from './external-api-domains';

const isMatch = (url: string) => {
  return !!url && !!CEFAuthenticateDomains.find(x => url.startsWith(x));
}

export const ErrorInterceptor = (axiosInstance: AxiosInstance, appContext?: AppStore) => {
  let state: Promise<any> | undefined;
  axiosInstance.interceptors.response.use(
    (config) => {
      return config;
    },
    (error) => {
      const { config, response } = error;
      // Handles initial calls that fail with a 401, tries to reAuth and the make the request again (will do one attempt)
      if (!config.isReAuthorizing && !config.hasRetried && response?.status === 401 && isMatch(config?.url)) {
        if (!appContext) {
          return;
        }
        config.isReAuthorizing = true;
        state = state || appContext.reInitAuth();

        state?.then(
          auth => {
            if (auth) {
              axiosInstance(config)
            }

            config.hasRetried = true;
            axiosInstance(config)
          },
          () => {
            config.hasRetried = true;
            axiosInstance(config)
          });

        state = undefined;
      }

      // Handles subsequent calls that fail with a 401 whilst a reauth attempt is currently being made
      if (state && config.isReAuthorizing && !config.hasRetried && response?.status === 401 && isMatch(config?.url)) {
        state = state.then(
          auth => {
            if (auth) {
              config.hasRetried = true;
              axiosInstance(config)
            }

            config.hasRetried = true;
            axiosInstance(config)
          },
          () => {
            config.hasRetried = true;
            axiosInstance(config)
          });

        state = undefined;
      }

      if (response?.status === 498 && response?.data?.Message === "Your showmax add-to-bill is already active") {
        // NOTE: This is to catch a Showmax Activation that has already happened - we should not poll the request in this scenario
        return Promise.reject({ status: response?.status, message: response?.data?.Message });
      }

      if (!config || !config.retry) {
        return Promise.reject(error);
      }

      config.retry -= 1
      const delayRetryRequest = new Promise<void>((resolve) => {
        setTimeout(() => {
          resolve();
        }, config.retryDelay || 0)
      })
      return delayRetryRequest.then(() => axiosInstance(config));
    }
  );
};